module.exports = __webpack_public_path__ + "static/6-36ad5a100cc0a4e2941607e1fc689559.png";